class PlusTabs {
  constructor() {
    const tabs = document.querySelectorAll('.elementor-widget-tabs.plus-tabs');

    if (tabs.length) {
      this.init();
    }
  }

  init() {
    const titles = document.querySelectorAll('.plus-tabs .elementor-tab-title');

    if (titles.length) {
      titles.forEach(title => {
        const plus = document.createRange().createContextualFragment("<span class='plus'></span>");

        title.appendChild(plus);
      });
    }
  }
}

export default PlusTabs;
